import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { CompanyList } from "../cmps/util-cmps/database";

interface CompaniesSlice {
  value: CompanyList[];
}

const initialState: CompaniesSlice = {
  value: [],
};

export const companiesSlice = createSlice({
  name: "companies",
  initialState,
  reducers: {
    update: (state, action) => {
      state.value= action.payload
    },
  },

});
export const {update} = companiesSlice.actions

export default companiesSlice.reducer;